<fieldset>
  <legend>
    {{ step3.getspan5 | translate }}
  </legend>
  <app-form-input [label]="" [name]="radioButtonCtrlName" [parentForm]="parentForm" [disabled]="disabled"
    [type]="'radio'" [rule]="'pattern_29'" [radios]="[
      {
      value: '',
      label: step3.getspan6
      },
      {
      value: critereCdc,
      label: step3.getcriterecdc
      },
      {
      value: criterePondere,
      label: step3.criterepondere
      },
      {
      value: critereLibre,
      label: step3.getcriterelibre
      },
      {
      value: criterePrix,
      label: step3.getcritereprix
      }
    ]" [value]="radioButtonValue">
  </app-form-input>
  <div *ngIf="isPondere()">
    <button [hidden]="disabled" class="btn btn-outline-primary" (click)="addcriterePondere()">{{ step3.getaddcritere | translate }}</button>
    <div *ngFor="let obj of criteresAttribution.criterePondere; let i = index">
      <fieldset>
        <legend></legend>
        <button [hidden]="disabled" *ngIf="i !== 0" class="btn btn-outline-primary" (click)="removecriterePondere(i)">{{
          step3.getdeletecritere | translate }}</button>
        <app-critere-pondere [uid]="getUid() + '_index_' + (i + 1)" [parentForm]="parentForm" [disabled]="disabled"
          [criterePondere]="obj">
        </app-critere-pondere>
      </fieldset>
    </div>
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
  </div>
  <div *ngIf="isLibre()">
    <app-form-input  [label]="step3.getcritere"
      [name]="getUid() + '_SepAtt_critereLibre'" [parentForm]="parentForm" [disabled]="disabled"
      [type]="'chips'" [rule]="'minSize_3|maxSize_1000'" [value]="criteresAttribution.critereLibre">
    </app-form-input>
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
  </div>
</fieldset>